<iframe *ngIf="safeUrl" frameborder="0" class="iframe-lg" [src]="safeUrl" id="map"> </iframe>
<!--<div #mapContainer id="map" class="iframe-lg"></div>-->